/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import {useRef, useEffect, useState} from 'react';
import JSG from '@cedalo/jsg-ui';

export const useJSGNotification = (notifications, handler, deps = []) => {
	const ref = useRef({ handler });

	useEffect(() => {
		JSG.NotificationCenter.getInstance().register(ref.current, notifications, 'handler');
		return () => JSG.NotificationCenter.getInstance().unregister(ref.current, notifications);
	}, deps);
};

export const useAsyncReference = (value) => {
	const ref = useRef(value);
	const [, forceRender] = useState(false);

	function updateState(newState) {
		ref.current = newState;
		forceRender((s) => !s);
	}

	return [ref, updateState];
};

